import { render } from "./MyConfirmation.vue?vue&type=template&id=71735c0e"
import script from "./MyConfirmation.vue?vue&type=script&lang=js"
export * from "./MyConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__